export type Locale = 'zh-CN' | 'en';

type ResolveLocaleInput = {
  pathname: string;
  storedLocale?: string | null;
  browserLanguages?: readonly string[];
};

export function resolveLocale(input: ResolveLocaleInput): Locale {
  if (input.pathname.startsWith('/zh/')) return 'zh-CN';
  if (input.pathname.startsWith('/en/')) return 'en';

  if (input.storedLocale === 'zh-CN' || input.storedLocale === 'en') {
    return input.storedLocale;
  }

  const firstLanguage = input.browserLanguages?.[0]?.toLowerCase() ?? '';
  if (firstLanguage.startsWith('zh')) return 'zh-CN';
  return 'en';
}
